// filepath: /C:/Users/nitis/Desktop/uii/client/src/recruiter Components/home Components/Create-Job.js
import { useState, useEffect, useMemo } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './create-job.module.css';
import SymbolsBar from '../shared/SymbolsBar'

const CreateJob = () => {
    const [job, setJob] = useState({
        title: '',
        description: '',
        location: '',
        requirements: '',
        benefits: ''
    });
    const [notification, setNotification] = useState('');
    const [cursorPos, setCursorPos] = useState({ requirements: 0 });
    const [skillSuggestions, setSkillSuggestions] = useState([]); // For dropdown suggestions
    const [searchQuery, setSearchQuery] = useState(''); // For tracking user input
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);

    const KeyCodes = {
        comma: 188,
        enter: 13,
      };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
    
    const [tags, setTags] = useState([]);
    
    const handleAddition = (tag) => {
        const normalizedText = tag.text.trim().toLowerCase().replace(/[^a-zA-Z0-9 ]/g, '');
        if (!tags.find(t => t.text === normalizedText)) {
          setTags([...tags, { id: normalizedText, text: normalizedText }]);
        }
      };
      
      const handleDelete = (i) => {
        setTags(tags.filter((tag, index) => index !== i));
      };

    const handleChange = (e) => {

        const { name, value } = e.target;
        setJob({ ...job, [name]: value });
    };

    const handleSymbolInsert = (field, updatedValue, newCursorPos) => {
        setJob(prev => ({ ...prev, [field]: updatedValue }));
        setTimeout(() => {
            const input = document.querySelector(`[name="${field}"]`);
            if (input) {
                input.focus();
                input.selectionStart = input.selectionEnd = newCursorPos;
            }
        }, 0);
    };

    const handleCursorChange = (field, position) => {
        setCursorPos(prev => ({ ...prev, [field]: position }));
    };
    

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        try {
            const jobData = { ...job, status, skills: tags.map(tag => tag.text) };

            const response = await axios.post('/api/recruiter/jobs/create-job', jobData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification(response.data.message);
            navigate('/recruiter/home');
        } catch (error) {
            // console.error('Error creating job:', error);
            setNotification(error.response.data.message);
        }
    };

    
    // Fetch skill suggestions from the backend
    useEffect(() => {
        const fetchSkills = async () => {
            if (searchQuery.trim() === '') {
                setSkillSuggestions([]);
                return;
            }

            try {
                const response = await axios.get(`/api/recruiter/jobs/search-skills?query=${searchQuery}`);
                setSkillSuggestions(response.data);
            } catch (error) {
                // console.error('Error fetching skill suggestions:', error);
            }
        };

        fetchSkills();
    }, [searchQuery]);

    const handleSkillInputChange = (input) => {
        setSearchQuery(input);
    };

    const handleSkillSelect = (skill) => {
        if (!tags.find(tag => tag.text === skill.name)) {
            setTags([...tags, { id: skill._id, text: skill.name }]);
        }
        setSearchQuery(''); // Clear the input
        setSkillSuggestions([]); // Clear suggestions
    };

    return (
        <div>
            <div className={styles.createJobContainer}>
                <h2>Create Job</h2>
                {notification && <p className={styles.notification}>{notification}</p>}
                <form className={styles.formStyle} onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                    <div className={styles.jobTitle}>
                        <label>Job Title:</label>
                        <input
                            type="text"
                            name="title"
                            value={job.title}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={styles.description}>
                        <label>Description:</label>
                        <textarea
                            name="description"
                            value={job.description}
                            onChange={handleChange}
                            onClick={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                            onKeyUp={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                            onSelect={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                        />
                        
                    </div>
                    <div className={styles.location}>
                        <label>Location:</label>
                        <textarea
                            type="text"
                            name="location"
                            value={job.location}
                            onChange={handleChange}
                            onClick={(e) => handleCursorChange('location', e.target.selectionStart)}
                            onKeyUp={(e) => handleCursorChange('location', e.target.selectionStart)}
                            onSelect={(e) => handleCursorChange('location', e.target.selectionStart)}
                        />
                    </div>
                    <div className={styles.requirements}>
                        <label>Requirements:</label>
                        <textarea
                            name="requirements"
                            value={job.requirements}
                            onChange={handleChange}
                            onClick={(e) => handleCursorChange('requirements', e.target.selectionStart)}
                            onKeyUp={(e) => handleCursorChange('requirements', e.target.selectionStart)}
                            onSelect={(e) => handleCursorChange('requirements', e.target.selectionStart)}
                        />
                        <SymbolsBar
                            value={job.requirements}
                            field="requirements"
                            cursorPosition={cursorPos.requirements}
                            onInsert={handleSymbolInsert}
                        />
                        </div>
                    <div className={styles.requirements}>
                        <label>Skills:</label>
                        <div className={styles.reactTagsContainer}>
                            <ReactTags classNames={{
                                            root: styles.reactTags,
                                            tagInput: styles.tagInput, 
                                            tag: styles.tag,
                                            remove: styles.remove
                                        }}
                                tags={tags}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                delimiters={delimiters}
                                handleInputChange={handleSkillInputChange}
                                placeholder="Type to search skills..."
                                autofocus={false}
                            />
                            {skillSuggestions.length > 0 && (
                                <ul className={styles.skillDropdown}>
                                    {skillSuggestions.map(skill => (
                                        <li
                                            key={skill._id}
                                            onClick={() => handleSkillSelect(skill)}
                                            className={styles.skillDropdownItem}
                                        >
                                            {skill.name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    
                    <div className={styles.benefits}>
                        <label>Benefits:</label>
                        <textarea
                            name="benefits"
                            value={job.benefits}
                            onChange={handleChange}
                            onClick={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                            onKeyUp={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                            onSelect={(e) => handleCursorChange('benefits', e.target.selectionStart)}
                        />
                    </div>
                    <div className={styles.formActions}>
                        <button className={styles.createJobButton} type="button" onClick={(e) => handleSubmit(e, 'liveJobs')}>Create Job</button>
                        <button className={styles.draftButton} type="button" onClick={(e) => handleSubmit(e, 'draftJobs')}>Save as Draft</button>
                        <button className={styles.discardButton} type="button" onClick={(e) => handleSubmit(e, 'deletedJobs')}>Discard</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
    );
};

export default CreateJob;